import { render, staticRenderFns } from "./switcher.vue?vue&type=template&id=0655bca8&scoped=true&"
import script from "./switcher.vue?vue&type=script&lang=js&"
export * from "./switcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0655bca8",
  null
  
)

export default component.exports